import { type CustomTooltipProps } from "ag-grid-react"

import { Badge } from "~/components/design-system/components"
import { PERFORMANCE_STATUSES } from "~/components/demand-2/tabs/performanceStatus"
import { formatName } from "~/utils/namingUtils"

import HeaderTooltip from "./HeaderTooltip"
import TooltipMessageCard from "./TooltipMessageCard"

/** The Status column: a legend of every status on the header, the cell's reason on a cell. */
const PerformanceStatusTooltip = (props: CustomTooltipProps & { primaryPeriod?: string }) => {
  if (props.location !== "header") {
    if (props.value == null || typeof props.value === "object") return null
    return <TooltipMessageCard>{props.value}</TooltipMessageCard>
  }
  const sales = formatName("sale", true, true)
  return (
    <HeaderTooltip {...props}>
      <div className="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-1.5 mt-2 paragraph-sm">
        {PERFORMANCE_STATUSES.map(({ status, badge, meaning }) => (
          <div key={status} className="contents">
            <Badge variant={badge}>{status}</Badge>
            <span>{meaning(sales)}</span>
          </div>
        ))}
      </div>
      {props.primaryPeriod && (
        <p className="paragraph-sm text-fg-muted mt-2">Primary period: {props.primaryPeriod}</p>
      )}
    </HeaderTooltip>
  )
}

export default PerformanceStatusTooltip
